exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".editable-select .text[data-v-1361f871]{border-bottom:1px dashed #aaa;cursor:pointer}.editable-select .v-select[data-v-1361f871]{background:#fff;min-width:15vw;color:#333}", ""]);

// exports
